module.exports = __webpack_public_path__ + "fa4b3b048755a8e69c490ac80b276405.MP3";